import { render, staticRenderFns } from "./consultProcessAll.vue?vue&type=template&id=bfdd241a&scoped=true&"
import script from "./consultProcessAll.vue?vue&type=script&lang=js&"
export * from "./consultProcessAll.vue?vue&type=script&lang=js&"
import style0 from "./consultProcessAll.vue?vue&type=style&index=0&id=bfdd241a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdd241a",
  null
  
)

export default component.exports